import {
  createStyles,
  TextField,
  type WithStyles,
  withStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import SelectDropdown from "components/SelectDropdown";
import React, { type ChangeEvent } from "react";
import { useFilterOptions } from "../hooks/useFilterOptions";
import type { LotGoalFilterFormState } from "../lotGoal.types";
import { LotGoalStatusFilter } from "../utils/lotGoal.utils";

type LotGoalFilterFormProps = {
  filterForm: LotGoalFilterFormState;
  onChangeFilter: <T extends keyof LotGoalFilterFormState>(
    field: T,
    value: LotGoalFilterFormState[T]
  ) => void;
} & WithStyles<typeof styles>;

function LotGoalFilterForm({
  classes,
  filterForm,
  onChangeFilter,
}: LotGoalFilterFormProps) {
  const { t } = useTranslations();
  const { statusOptions } = useFilterOptions();

  const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    onChangeFilter("searchText", event.target.value);
  };

  const handleChangeStatus = (value: LotGoalStatusFilter) => {
    onChangeFilter("status", value);
  };

  return (
    <div className={classes.root}>
      <TextField
        autoFocus={true}
        className={classes.searchField}
        data-testid="search-filter-field"
        label={t("livestock:search-livestock-goal")}
        onChange={handleChangeSearch}
        value={filterForm.searchText}
      />

      <SelectDropdown
        className={classes.statusSelect}
        data-testid="status-select"
        label={{ text: t("livestock:goal-status") }}
        options={statusOptions}
        value={filterForm.status}
        onChange={handleChangeStatus}
      />
    </div>
  );
}

const styles = () =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      paddingTop: "20px",
      width: "100%",
    },
    searchField: {
      width: "400px",
    },
    statusSelect: {
      maxWidth: 200,
      width: "100%",
    },
  });

export default withStyles(styles)(LotGoalFilterForm);
